exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".show_bb5ebd3{display:flex}.show_bb5ebd3 .item_ec8278c{flex:1;padding-right:10px;margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"show": "show_bb5ebd3",
	"item": "item_ec8278c"
};